import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { LogoLeftPanel } from 'src/common/images/LogoLeftPanel';
import { HomepageRoute } from 'src/public/publicRoutes';
import { StaticPanelLeftItem } from 'src/public/components/static-page/StaticPanelLeftItem';
import { media } from 'src/config/breakpoints';
import { GatsbyLink } from 'src/common/migration/GatsbyLink';
import { PartnerLogoDesktop } from 'src/common/components/PartnerLogoDesktop';
import { StaticPagePanelItem } from 'src/common/models/staticPage';

const Container = styled.div`
  align-self: flex-start;
  padding-bottom: 2.5rem;
  position: sticky;
  top: 0;
  width: 100%;

  ${media.w.min.px768(css`
    padding-bottom: 6.25rem;
  `)};
`;

const StyledLink = styled(GatsbyLink)`
  display: inline-block;
  margin: 2.375rem 0 clamp(1.5625rem, 10vh, 5.9375rem) 2.125rem;
`;

const StyledPartnerLogoDesktop = styled(PartnerLogoDesktop)`
  && {
    margin-top: calc(clamp(1.5625rem, 10vh, 5.9375rem) * -1 + 0.9375rem);
  }
`;

interface StaticPanelLeftProps {
  activeItem?: string;
  items?: StaticPagePanelItem[];
}

export const StaticPanelLeft: FC<StaticPanelLeftProps> = ({ activeItem, items }) => (
  <Container>
    <StyledLink to={HomepageRoute}>
      <LogoLeftPanel />
    </StyledLink>

    <StyledPartnerLogoDesktop />

    {items?.map((item) => (
      <StaticPanelLeftItem active={activeItem === item.id} panelItem={item} key={item.id} />
    ))}
  </Container>
);
